import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Dialog, DialogContent } from '@ui/components/ui/dialog'
import { DownloadIcon } from 'lucide-react'
import { useDataStore } from '@/lib/machine/use-data-store'
import { useFirmwareVersions } from '@/lib/firmware-update/use-firmware-versions'
import { useFirmwareInstall } from '@/lib/firmware-update/use-firmware-install'
import { FirmwareUpdateContent } from './firmware-update-content'
import { PowerButton } from '@/components/settings/power-button'

/** Button that opens the firmware dialog on demand. For the settings page. */
export function FirmwareUpdateTrigger() {
  const { t } = useTranslation()
  const versions = useFirmwareVersions()
  const machineId = useDataStore(s => s.machineId)
  const isOnline = useDataStore(s => s.isOnline)
  const { state, isBusy, install, reset } = useFirmwareInstall()

  const [open, setOpen] = useState(false)

  const handleOpenChange = (newOpen: boolean) => {
    if (!newOpen && !isBusy) {
      setOpen(false)
      reset()
    } else {
      setOpen(newOpen)
    }
  }

  if (!versions.updateAvailable) return null

  return (
    <>
      <PowerButton
        label={t('settings.machine.firmware-update-button')}
        aria-label={t('settings.machine.firmware-update-button')}
        onClick={() => setOpen(true)}
        disabled={!isOnline || !machineId}
        className="w-full"
      >
        <DownloadIcon className="w-8" />
      </PowerButton>

      <Dialog open={open} onOpenChange={handleOpenChange}>
        <DialogContent
          className="max-h-1/2 p-16 [&>button:last-child]:hidden"
          onPointerDownOutside={e => {
            if (isBusy) e.preventDefault()
          }}
          onEscapeKeyDown={e => {
            if (isBusy) e.preventDefault()
          }}
        >
          <FirmwareUpdateContent
            versions={versions}
            state={state}
            onInstall={install}
            onClose={() => handleOpenChange(false)}
            isOnline={isOnline}
          />
        </DialogContent>
      </Dialog>
    </>
  )
}
